module.exports = __webpack_public_path__ + "media/asset/images/yahoo-995263580874317357c71e94e570a487.png";